import React, { FC } from 'react';
import styles from './Header.scss';
import WixLogo from 'assets/svgs/wix-logo.svg';

export const HeaderLogo: FC = () => {
  return (
    <div className={styles.headerLogo}>
      <WixLogo />
    </div>
  );
};
